import type {TranscriptItem} from '@PosterWhiteboard/items/transcript-item/transcript-item';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

export function useGetSelectedTranscriptItem(): TranscriptItem | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  if (!activeItem) {
    return null;
  }

  if (!activeItem.isTranscript()) {
    return null;
  }

  return activeItem;
}
